import React from "react"

const ALink = ({ isTextColor, isUnderlined, inheritColor, ...otherProps }) => (
  <a
    sx={{
      color: inheritColor ? "inherit" : isTextColor ? "text" : "primary",
      textDecoration: isUnderlined ? "underline" : "none",
      "&:hover, &:focus": {
        color: inheritColor ? "inherit" : "primaryLight",
      },
    }}
    {...otherProps}
  />
)

export default ALink
